// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"225":"6ec90c98","261":"6ec90c98","273":"6ec90c98","428":"6ec90c98","579":"6ec90c98","652":"6ec90c98","853":"6ec90c98"}[chunkId] + ".chunk.css";
};